module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alexander Key\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Alexander Key (1904–1979) started out as an illustrator before he began writing science fiction novels for young readers. He has published many titles, including "), _c('I', [_vm._v("Sprockets: A Little Robot")]), _vm._v(","), _c('I', [_vm._v(" Mystery of the Sassafras Chair")]), _vm._v(", and "), _c('I', [_vm._v("The Forgotten Door")]), _vm._v(", winner of the Lewis Carroll Shelf Award"), _c('I', [_vm._v(". ")]), _vm._v("Key’s novel "), _c('I', [_vm._v("Escape to Witch Mountain")]), _vm._v(" was adapted for film in 1975, 1995, and 2009. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tJCvni/tc-custom/9781497652613.jpg?1705635368971",
      "alt": "This image is the cover for the book Magic Meadow"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Magic Meadow\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In the dark of a grim hospital ward, five children escape to another world")]), _c('br'), _c('br'), _vm._v("They call themselves the incurables. They are five children doomed to spend their lives in Belleview’s Ward Nine, unable to walk, care for themselves, or even take a trip outside. Their days are gloomy, but they have one another, and at night they play the game. Whispering about places that could never be, they build worlds so vivid that they almost seem real. And then one night, their dreams come true."), _c('br'), _vm._v(" "), _c('br'), _vm._v("While the others sleep, Brick closes his eyes and thinks harder than he ever has about the place he calls the Magic Meadow—a lush hill where dandelions grow. When he opens his eyes, he has been transported. The meadow is real, and with his friends at his side, he will return there again and again—to learn, to walk, to live. "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0